<template>
  <div
    class="dropdown"
    :class="{
      opened: open
    }"
    :id="id"
  >
    <v-popover trigger="click" :open.sync="open" :container="containerSelector">
      <div
        class="dropdown-controls"
        :class="{
          opened: open,
          'has-checked': hasChecked
        }"
      >
        <span class="name">{{ name }}</span>
        <i class="icon ficon" :class="iconClasses"></i>
      </div>
      <template #popover>
        <v-checkbox
          v-for="(option, index) in options"
          :key="index"
          :value="value"
          @input="$emit('input', $event)"
          :val="option.id"
          @change="$emit('change', $event)"
          >{{ option.name }}</v-checkbox
        >
      </template>
    </v-popover>
  </div>
</template>

<script>
import { generateId } from "@/utils/helpers.js";
export default {
  name: "CheckboxGroup",
  props: {
    value: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      id: generateId(),
      model: [],
      open: false
    };
  },
  computed: {
    optionsIds() {
      return this.options.map(item => item.id);
    },
    hasChecked() {
      return this.value.some(v => this.optionsIds.includes(v));
    },
    containerSelector() {
      return "#" + this.id;
    },
    iconClasses() {
      return [this.open ? "ficon-arrow-up" : "ficon-arrow-bottom"];
    }
  }
};
</script>

<style lang="scss" scoped>

@import "~@/assets/scss/base/color.scss";
@import "~@/assets/scss/base/var.scss";
.dropdown {
  position: relative;
  display: inline-block;
  &.opened {
    z-index: 20;
  }

  &-controls {
    cursor: pointer;
    position: relative;
    display: inline-flex;
    z-index: 1;
    white-space: nowrap;
    max-width: 100px;
    color: $color-grey-2;
    .name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &::before {
      content: "";
      position: absolute;
      background: #fff;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      margin: -9px -15px -4px -15px;
      z-index: -1;
      border-radius: 2px 2px 0 0;
      border: $default-border;
      border-color: $theme-color;
      // border-bottom-width: 0;
      opacity: 0;
      border-bottom-color: #fff;
      transition: opacity $primary-transition;
    }
    &::after {
      position: absolute;
      content: "";
      height: 2px;
      background: #fff;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0 -15px;
      margin-bottom: -5px;
      // opacity: 0;
      transition: opacity $primary-transition;
    }
    &.opened {
      z-index: 21;
      &::before {
        opacity: 1;
      }
    }

    &.has-checked {
      color: $theme-color;
    }

    .icon {
      margin-left: 4px;
      color: $color-grey-6;
    }
  }
  &-content {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    // margin-top: 10px;
    // margin-left: -15px;
    background: #fff;
  }

  ::v-deep {
    .v-popover {
      z-index: 1;
    }
    .tooltip {
      z-index: inherit;
      margin-top: 2px;
      transition: opacity $primary-transition;
      outline: none;
      width: 575px;
      &-arrow {
        display: none;
      }

      .popover-inner {
        box-shadow: none;
        border: $default-border;
        border-color: $theme-color;
        border-radius: 2px;
        padding: 13px 20px;
        line-height: 20px;
        box-shadow: 0px 2px 6px 0px rgba(220, 220, 220, 0.5);
      }
    }
  }

  // &:hover{
  //     .dropdown{
  //         &-controls::after{
  //             display: block;
  //             border-color: $theme-color;
  //         }
  //         &-content{
  //             display: block;
  //             border-color: $theme-color;
  //         }
  //     }

  // }
}

</style>
